import routerOptions0 from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.2615541/source/frontend/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.0__@babel+plugin-s_fed38d0b34271c6ff30c5cabc238faed/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.2615541/source/frontend/apps/site/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}